import { AnnouncementAdminServiceDefinition } from '@zennolab_platform/data-access-notification-service-api';
import {
  type CallOptions,
  type ClientMiddlewareCall,
  createChannel,
  createClientFactory,
  Metadata,
} from 'nice-grpc-web';

import type { AnnouncementApi } from './types';

export function bearerMiddleware(getToken: () => Promise<string>) {
  return async function* bearer<Request, Response>(
    call: ClientMiddlewareCall<Request, Response>,
    options: CallOptions,
  ) {
    const metadata = Metadata(options.metadata);
    metadata.set('authorization', `Bearer ${await getToken()}`);
    return yield* call.next(call.request, { ...options, metadata });
  };
}

export function createAnnouncementApi(url: string, getToken: () => Promise<string>): AnnouncementApi {
  return createClientFactory()
    .use(bearerMiddleware(getToken))
    .create(AnnouncementAdminServiceDefinition, createChannel(url));
}
